import { Option } from "../question_helpers";

export interface Answer {
  selectedOption?: string | Option | undefined;
  writeIn?: string;
  followUpResponse?: string;
  label?: string;
}

export interface Customizations {
  prompt: string;
  description?: string;
  options: (string | Option)[];
  followUp?: {
    option: string;
    optional?: boolean;
    prompt: string;
    includeOpenResponse: boolean;
    placeholder?: string;
  };
  optional?: boolean;
  withOtherOption?: Option;
}

export function isOptional(customizations: Customizations) {
  return typeof customizations.optional === "undefined" ? false : customizations.optional;
}

export function getOptionsForSelectComponent(options: (string | Option)[], otherOption?: Option) {
  const optionsForSelectComponent = options
    .filter((option) => option)
    .map((option) => {
      if (typeof option === "object") {
        return { id: option.oid, label: option.text };
      } else if (typeof option === "string") {
        const snakeCaseOption = option
          .replace(/[^a-zA-Z0-9👍👎\s]/gu, "")
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "_");
        return { id: snakeCaseOption, label: option };
      }
      return { id: option, label: option };
    });
  const optionsIncludeOtherOption = optionsForSelectComponent
    .map((option) => option.id)
    .includes(otherOption?.oid as string);

  // If 'Other' option isn't included already, add it to the end of the list
  // Adding this extra bit to check if this option is already present in the array because for some reason
  // it was being added multiple times.
  if (otherOption?.oid && !optionsIncludeOtherOption) {
    optionsForSelectComponent.push({ id: otherOption.oid, label: otherOption.text });
  }
  return optionsForSelectComponent;
}

export function getQuestionOptions(options: (string | Option)[], otherOption?: Option) {
  const questionOptions = options.map((option) => option as Option);

  const questionOptionsIncludesOtherOption = questionOptions
    .map((option) => option.oid)
    .includes(otherOption?.oid as string);

  // If 'Other' option isn't included already, add it to the end of the list
  // Adding this extra bit to check if this option is already present in the array because for some reason
  // it was being added multiple times.
  if (otherOption && !questionOptionsIncludesOtherOption) {
    questionOptions.push(otherOption);
  }
  return questionOptions;
}
